import { render, staticRenderFns } from "./DeptUserAddModal.vue?vue&type=template&id=2735ba32"
import script from "./DeptUserAddModal.vue?vue&type=script&lang=js"
export * from "./DeptUserAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports